import React, { useState } from 'react';
import CharacterList from "./CharacterList";
import CreateCharacter from './CreateCharacter';
import DisplayCharacter from './DisplayCharacter';

import Cookies from 'js-cookie';

export default function AppMain() {

    // cookies

    function GetSavedCharacterData() {
        //const characterData = Cookies.get('characterData');
        const characterData = localStorage.getItem('characterData');
        if (characterData !== null && characterData !== undefined) {
            return JSON.parse(characterData);
        }
        return [];
    }

    function SetSavedCharacterData(characters) {
        localStorage.setItem('characterData', JSON.stringify(characters));
        //Cookies.set('characterData', JSON.stringify(characters));
    }

    // data

    const [selectedView, setSelectedView] = useState("MAIN");
    const [characters, setCharacters]
        = useState(GetSavedCharacterData());
    const [isEditing, setIsEditing] = useState(false);
    const [selectedCharcater, setSelectedCharacter] = useState(null);

    function goToCreateCharacter() {
        setIsEditing(false);
        setSelectedCharacter(null);
        setSelectedView("CREATE_EDIT_CHARACTER");
    }

    return (
        <main>
            {selectedView === "MAIN" && (
                <div style={{
                    display: "flex",
                    justifyContent: "center"
                }} >
                <div style={{
                    width: "950px",
                    display: "flex",
                    justifyContent: "center", flexDirection: "column"
                }}>
                    
                        <CharacterList characters={characters}
                            setCharacters={setCharacters}
                            setSavedCharacters={SetSavedCharacterData}
                            setSelectedView={setSelectedView}
                            setIsEditing={setIsEditing}
                            setSelectedCharacter={setSelectedCharacter}
                            createCharacterAction={goToCreateCharacter}
                        />
                    </div>
            </div>
            )}
            {selectedView === "CREATE_EDIT_CHARACTER" && (
                <div style={{
                    display: "flex", justifyContent: "center",
                    flexDirection: "column", alignItems: "center"
                }}>
                    <h3>Create Character</h3>
                    <CreateCharacter
                        isEditing={isEditing}
                        setSelectedView={setSelectedView}
                        characters={characters}
                        setCharacters={setCharacters}
                        setSavedCharacters={SetSavedCharacterData}
                        editedCharacter={selectedCharcater}
                        setSelectedCharacter={setSelectedCharacter}
                    />
                </div>
            )}
            {
                selectedView === "DISPLAY_CHARACTER" && (
                    <div style={{display: "flex", justifyContent: "center" }} >
                        <DisplayCharacter
                            displayedCharacter={selectedCharcater}
                            setSelectedView={setSelectedView}
                            characters={characters}
                            setCharacters={setCharacters}
                            setSavedCharacters={SetSavedCharacterData}
                            setSelectedCharacter={setSelectedCharacter}
                            setIsEditing={setIsEditing}
                        />
                    </div>
                )
            }
        </main>
    );
}